module.exports = __webpack_public_path__ + "img/logoMenu.f1bcf749.png";